import { useTranslation } from 'react-i18next';
import React from 'react';

import { composeClassName } from '../../../../../../../../../utils/util_helpers';
import { OutgoingTransactionStatusCellContentProps } from './types';
import { theme } from '@/utils/util_theme';
import { IconSaxIcon } from '@/components/design-system/atoms/icon';
import { IconSaxIconName } from '@/components/design-system/atoms/icon/iconsax-icon/types';

export type PayoutPaymentStatus =
  | 'unsigned'
  | 'pending'
  | 'accepted'
  | 'completed'
  | 'rejected'
  | 'cancelled'
  | 'unknown';

const OutgoingTransactionStatusCellContent: React.FC<OutgoingTransactionStatusCellContentProps> = ({
  status,
}) => {
  const { t } = useTranslation();

  const bgColor: { [key in PayoutPaymentStatus]: string } = {
    unsigned: 'bg-E30',
    pending: 'bg-R50',
    accepted: 'bg-J50',
    completed: 'bg-J50',
    rejected: 'bg-C50',
    cancelled: 'bg-E30',
    unknown: 'bg-E30',
  };

  const borderColor: { [key in PayoutPaymentStatus]: string } = {
    unsigned: 'border-transparent',
    pending: 'border-transparent',
    accepted: 'border-transparent',
    completed: 'border-transparent',
    rejected: 'border-C300',
    cancelled: 'border-transparent',
    unknown: 'border-E75',
  };

  const textColor: { [key in PayoutPaymentStatus]: string } = {
    unsigned: theme.colors.E100,
    pending: theme.colors.R500,
    accepted: theme.colors.J300,
    completed: theme.colors.J300,
    rejected: theme.colors.C300,
    cancelled: theme.colors.E100,
    unknown: theme.colors.E100,
  };

  const iconName: { [key in PayoutPaymentStatus]: IconSaxIconName } = {
    unsigned: 'minus-cirlce',
    pending: 'clock-1',
    accepted: 'tick-circle',
    completed: 'tick-circle',
    rejected: 'close-circle',
    cancelled: 'close-circle',
    unknown: 'information',
  };

  return (
    <div className="inline-block">
      <div
        className={composeClassName(
          'flex items-center gap-1 rounded-[19px] border-[1px] border-solid px-2 py-1',
          borderColor[status],
          bgColor[status]
        )}
      >
        <IconSaxIcon
          size={18}
          strokeColor={textColor[status]}
          name={iconName[status]}
          strokeWidth={1.3}
        />
        <span className={composeClassName('text-body')} style={{ color: textColor[status] }}>
          {t(
            `js.features.admin.transactions.outgoing_transactions_list.transaction_status.${status}`
          )}
        </span>
      </div>
    </div>
  );
};

export { OutgoingTransactionStatusCellContent };
